module.exports = __webpack_public_path__ + "img/transparencia.0cb28009.svg";